import { getAmplitudeInstance } from '../amplitudeHelpers';

/**
 * User views the getting started welcome screen.
 */
const logPostSignUpScreenViewed = (callback?: () => void) => {
  getAmplitudeInstance().logEvent('post sign up screen viewed', {}, callback);
};

export default logPostSignUpScreenViewed;
